import { slice } from './slice';

export const { userDetailsChanged, accessibleFacilitiesChanged, accessControlsChanged } = slice.actions;
